import React from "react";

/**
 * Tiny markdown renderer for headings (##, ###), paragraphs, blank-line breaks, and links [text](url).
 * Used for editable legal pages.
 */
function renderInline(text) {
  // bold **text**
  const parts = [];
  const linkRe = /\[([^\]]+)\]\(([^)]+)\)/g;
  let lastIndex = 0;
  let m;
  while ((m = linkRe.exec(text)) !== null) {
    if (m.index > lastIndex) parts.push(text.slice(lastIndex, m.index));
    parts.push(
      <a key={parts.length} href={m[2]} target="_blank" rel="noreferrer" className="text-[#0055FF] hover:underline">
        {m[1]}
      </a>
    );
    lastIndex = m.index + m[0].length;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return parts;
}

export default function SimpleMarkdown({ text }) {
  if (!text || !text.trim()) return null;
  const lines = text.split(/\r?\n/);
  const blocks = [];
  let buffer = [];

  const flushPara = () => {
    if (buffer.length > 0) {
      blocks.push(
        <p key={blocks.length} className="text-sm leading-relaxed text-foreground/90">
          {renderInline(buffer.join(" "))}
        </p>
      );
      buffer = [];
    }
  };

  for (const raw of lines) {
    const line = raw.trim();
    if (!line) {
      flushPara();
      continue;
    }
    if (line.startsWith("### ")) {
      flushPara();
      blocks.push(
        <h4 key={blocks.length} className="font-semibold text-base mt-3 mb-1">
          {renderInline(line.slice(4))}
        </h4>
      );
    } else if (line.startsWith("## ")) {
      flushPara();
      blocks.push(
        <h3 key={blocks.length} className="font-semibold text-lg mt-4 mb-1">
          {renderInline(line.slice(3))}
        </h3>
      );
    } else if (line.startsWith("# ")) {
      flushPara();
      blocks.push(
        <h2 key={blocks.length} className="font-bold text-xl mt-4 mb-1">
          {renderInline(line.slice(2))}
        </h2>
      );
    } else {
      buffer.push(line);
    }
  }
  flushPara();
  return <div className="space-y-3">{blocks}</div>;
}
